import type { ReviewQuestion } from '@/types/review/ReviewQuestion';

import { api } from '@/api/api';
import { filterOutOtherOption } from '@/utils/question';

export default {
    async createReviewQuestion(reviewQuestion: ReviewQuestion) {
        const response = await api.post('/reviewquestion', reviewQuestion);
        return response.data;
    },

    async updateReviewQuestion(reviewQuestion: ReviewQuestion) {
        const payload: ReviewQuestion = {
            ...reviewQuestion,
            reviewQuestionOptions: filterOutOtherOption(reviewQuestion.reviewQuestionOptions),
        };
        const response = await api.put(`/reviewquestion/${reviewQuestion.id}`, payload);
        return response.data;
    },

    async deleteReviewQuestion(reviewQuestionId: string) {
        const response = await api.delete(`/reviewquestion/${reviewQuestionId}`);
        return response.data;
    },

    async getQuestionComments(reviewQuestionId: string) {
        const response = await api.get(`/reviewquestion/${reviewQuestionId}/comment`);
        return response.data;
    },
};
